import { defineComponent as _defineComponent } from 'vue'
import Info from '@/components/DynamicInfo.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { useVuetify } from '@/composables/useVuetify';
import { TipoObra } from '@/constants';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CamposArtigoPeriodico',
  setup(__props) {

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);

const possuiPublicacao = computed(() => obra.value?.obraEditoraList?.length);

const getPathLocalizacao = (cdObraColecaoPeriodico: number) => {
  return {
    path: `/obras/visualiza/${cdObraColecaoPeriodico}/${TipoObra.COLECAO_PERIODICO}`,
    query: { back: 'true' },
  };
};

return { __sfc: true,vuetify, store, obra, possuiPublicacao, getPathLocalizacao, Info }
}

})